import { render, staticRenderFns } from "./RemoverTomador.vue?vue&type=template&id=1fd64315&scoped=true&"
import script from "./RemoverTomador.vue?vue&type=script&lang=js&"
export * from "./RemoverTomador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd64315",
  null
  
)

export default component.exports